import { render, staticRenderFns } from "./logo-column.vue?vue&type=template&id=4461ee29&scoped=true"
import script from "./logo-column.vue?vue&type=script&lang=js"
export * from "./logo-column.vue?vue&type=script&lang=js"
import style0 from "./logo-column.vue?vue&type=style&index=0&id=4461ee29&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4461ee29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4461ee29')) {
      api.createRecord('4461ee29', component.options)
    } else {
      api.reload('4461ee29', component.options)
    }
    module.hot.accept("./logo-column.vue?vue&type=template&id=4461ee29&scoped=true", function () {
      api.rerender('4461ee29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/brand/logo-column.vue"
export default component.exports